import { AsyncAction } from "../../../types/actions";
import * as AnalyticsFetcher from "../../../connection/analytics";

export const GET_CHANNEL_EVENTS = "GET_CHANNEL_EVENTS";
export function getChannelEvents(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_EVENTS,
		promise: AnalyticsFetcher.GetChannelEvents(channel, token)
	};
}

export const GET_CHANNEL_DEVICE_TYPES = "GET_CHANNEL_DEVICE_TYPES";
export function getChannelDeviceTypes(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_DEVICE_TYPES,
		promise: AnalyticsFetcher.GetChannelDeviceTypes(channel, token)
	};
}

export const GET_CHANNEL_BROWSERS = "GET_CHANNEL_BROWSERS";
export function getChannelBrowsers(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_BROWSERS,
		promise: AnalyticsFetcher.GetChannelBrowsers(channel, token)
	};
}

export const GET_CHANNEL_AUDIENCE = "GET_CHANNEL_AUDIENCE";
export function getChannelAudience(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_AUDIENCE,
		promise: AnalyticsFetcher.GetChannelAudience(channel, token)
	};
}

export const GET_CHANNEL_REGISTRATIONS = "GET_CHANNEL_REGISTRATIONS";
export function getChannelRegistrations(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_REGISTRATIONS,
		promise: AnalyticsFetcher.GetChannelRegistrations(channel, token)
	};
}

export const GET_CHANNEL_DURATION = "GET_CHANNEL_DURATION";
export function getChannelDurations(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_DURATION,
		promise: AnalyticsFetcher.GetChannelDurations(channel, token)
	};
}

export const GET_CHANNEL_VIEWS = "GET_CHANNEL_VIEWS";
export function getChannelViews(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_VIEWS,
		promise: AnalyticsFetcher.GetChannelViews(channel, token)
	};
}

export const GET_CHANNEL_WATCHTIME = "GET_CHANNEL_WATCHTIME";
export function getChannelWatchTime(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_WATCHTIME,
		promise: AnalyticsFetcher.GetChannelWatchtime(channel, token)
	};
}

export const GET_CHANNEL_RETENTION_AVERAGE = "GET_CHANNEL_RETENTION_AVERAGE";
export function getChannelRetentionAverage(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_RETENTION_AVERAGE,
		promise: AnalyticsFetcher.GetChannelRetentionAverage(channel, token)
	};
}

export const GET_CHANNEL_RETENTION_BUCKETS = "GET_CHANNEL_RETENTION_BUCKETS";
export function getChannelRetentionBuckets(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_RETENTION_BUCKETS,
		promise: AnalyticsFetcher.GetChannelRetentionBuckets(channel, token)
	};
}

export const GET_CHANNEL_REGIONS = "GET_CHANNEL_REGIONS";
export function getChannelRegions(channel: number, token: string): AsyncAction {
	return {
		type: GET_CHANNEL_REGIONS,
		promise: AnalyticsFetcher.GetChannelRegions(channel, token)
	};
}

export const GET_EVENT_DEVICE_TYPES = "GET_EVENT_DEVICE_TYPES";
export function getEventDeviceTypes(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_DEVICE_TYPES,
		promise: AnalyticsFetcher.GetEventDeviceTypes(uuid, token)
	};
}
export const GET_EVENT_REGIONS = "GET_EVENT_REGIONS";
export function getEventRegions(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_REGIONS,
		promise: AnalyticsFetcher.GetEventRegions(uuid, token)
	};
}
export const GET_EVENT_LANGUAGES = "GET_EVENT_LANGUAGES";
export function getEventLanguages(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_LANGUAGES,
		promise: AnalyticsFetcher.GetEventLanguages(uuid, token)
	};
}
export const GET_EVENT_VIEWS = "GET_EVENT_VIEWS";
export function getEventViews(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_VIEWS,
		promise: AnalyticsFetcher.GetEventViews(uuid, token)
	};
}
export const GET_EVENT_DURATION = "GET_EVENT_DURATION";
export function getEventDuration(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_DURATION,
		promise: AnalyticsFetcher.GetEventDuration(uuid, token)
	};
}

export const GET_EVENT_RETENTION_AVERAGE = "GET_EVENT_RETENTION_AVERAGE";
export function getEventRetentionAverage(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_RETENTION_AVERAGE,
		promise: AnalyticsFetcher.GetEventRetentionAverage(uuid, token)
	};
}

export const GET_EVENT_RETENTION_BUCKETS = "GET_EVENT_RETENTION_BUCKETS";
export function getEventRetentionBuckets(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_RETENTION_BUCKETS,
		promise: AnalyticsFetcher.GetEventRetentionBuckets(uuid, token)
	};
}

export const GET_EVENT_REGISTRATION_ANALYTICS = "GET_EVENT_REGISTRATIONS_ANALYTICS";
export function getEventRegistrations(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_REGISTRATION_ANALYTICS,
		promise: AnalyticsFetcher.GetEventRegistrations(uuid, token)
	};
}

export const GET_EVENT_EMAILS = "GET_EVENT_EMAILS";
export function getEventEmails(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_EMAILS,
		promise: AnalyticsFetcher.GetEventEmails(uuid, token)
	};
}
export const GET_EVENT_WATCHTIME = "GET_EVENT_WATCHTIME";
export function getEventWatchtime(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_WATCHTIME,
		promise: AnalyticsFetcher.GetEventWatchtime(uuid, token)
	};
}

export const GET_EVENT_BROWSERS = "GET_EVENT_BROWSERS";
export function getEventBrowsers(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_BROWSERS,
		promise: AnalyticsFetcher.GetEventBrowsers(uuid, token)
	};
}
export const GET_EVENT_SESSIONS = "GET_EVENT_SESSIONS";
export function getEventSessions(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_SESSIONS,
		promise: AnalyticsFetcher.GetEventSessions(uuid, token)
	};
}
export const GET_EVENT_COUNTRY_MAP = "GET_EVENT_COUNTRY_MAP";
export function getEventCountryMap(uuid: string, token: string): AsyncAction {
	return {
		type: GET_EVENT_COUNTRY_MAP,
		promise: AnalyticsFetcher.GetEventMapData(uuid, token)
	};
}

export const GET_SESSION_DEVICE_TYPES = "GET_SESSION_DEVICE_TYPES";
export function getSessionDeviceTypes(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_DEVICE_TYPES,
		promise: AnalyticsFetcher.GetSessionDeviceTypes(uuid, token)
	};
}
export const GET_SESSION_REGIONS = "GET_SESSION_REGIONS";
export function getSessionRegions(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_REGIONS,
		promise: AnalyticsFetcher.GetSessionRegions(uuid, token)
	};
}
export const GET_SESSION_LANGUAGES = "GET_SESSION_LANGUAGES";
export function getSessionLanguages(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_LANGUAGES,
		promise: AnalyticsFetcher.GetSessionLanguages(uuid, token)
	};
}
export const GET_SESSION_VIEWS = "GET_SESSION_VIEWS";
export function getSessionViews(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_VIEWS,
		promise: AnalyticsFetcher.GetSessionViews(uuid, token)
	};
}
export const GET_SESSION_DURATION = "GET_SESSION_DURATION";
export function getSessionDuration(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_DURATION,
		promise: AnalyticsFetcher.GetSessionDuration(uuid, token)
	};
}
export const GET_SESSION_RETENTION_AVERAGE = "GET_SESSION_RETENTION_AVERAGE";
export function getSessionRetentionAverage(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_RETENTION_AVERAGE,
		promise: AnalyticsFetcher.GetSessionRetentionAverage(uuid, token)
	};
}
export const GET_SESSION_REGISTRATIONS = "GET_SESSION_REGISTRATIONS";
export function getSessionRegistrations(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_REGISTRATIONS,
		promise: AnalyticsFetcher.GetSessionRegistrations(uuid, token)
	};
}
export const GET_SESSION_EMAILS = "GET_SESSION_EMAILS";
export function getSessionEmails(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_EMAILS,
		promise: AnalyticsFetcher.GetSessionEmails(uuid, token)
	};
}
export const GET_SESSION_WATCHTIME = "GET_SESSION_WATCHTIME";
export function getSessionWatchtime(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_WATCHTIME,
		promise: AnalyticsFetcher.GetSessionWatchtime(uuid, token)
	};
}
export const GET_SESSION_BROWSERS = "GET_SESSION_BROWSERS";
export function getSessionBrowsers(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_BROWSERS,
		promise: AnalyticsFetcher.GetSessionBrowsers(uuid, token)
	};
}
export const GET_SESSION_TIMELINE = "GET_SESSION_TIMELINE";
export function getSessionTimeline(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_TIMELINE,
		promise: AnalyticsFetcher.GetSessionTimeline(uuid, token)
	};
}

export const GET_SESSION_COUNTRY_MAP = "GET_SESSION_COUNTRY_MAP";
export function getSessionCountryMap(uuid: string, token: string): AsyncAction {
	return {
		type: GET_SESSION_COUNTRY_MAP,
		promise: AnalyticsFetcher.GetSessionMapData(uuid, token)
	};
}